<template>
  <b-form-group :label="label" :label-for="inputId" :description="description">
    <div v-if="isLoading" class="d-flex align-items-center mb-2">
      <b-spinner small type="grow" label="Carregando..." />
      <span class="ml-2">Carregando responsáveis...</span>
    </div>
    <b-form-select
      :id="inputId"
      v-model="internalValue"
      :options="responsibleUserOptions"
      :required="required"
      :state="isValid"
      @change="handleChange"
      @blur="handleBlur"
    >
      <option disabled value="">Selecione...</option>
    </b-form-select>
    <b-form-invalid-feedback :id="`${inputId}-feedback`">
      {{ invalidFeedback }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  name: 'ResponsibleUserSelect',
  props: {
    value: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: 'Usuário responsável',
    },
    inputId: {
      type: String,
      default: 'responsible-user-select-input',
    },
    description: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
    },
    invalidFeedback: {
      type: String,
      default: 'Por favor, selecione um usuário responsável.',
    },
    validationFunc: {
      type: Function,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value,
      isValid: this.state,
      responsibleUserOptions: [{ value: '', text: 'Selecione...' }],
      isLoading: false,
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
      this.validate();
    },
    state(newVal) {
      this.isValid = newVal;
    },
  },
  mounted() {
    this.fetchResponsibleUsers();
  },
  methods: {
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    handleChange() {
      this.$emit('input', this.internalValue);
      this.validate();
    },
    handleBlur() {
      this.validate();
    },
    validate() {
      if (!this.validationFunc) {
        this.isValid = this.required ? !!this.internalValue : null;
      } else {
        this.isValid = this.validationFunc(this.internalValue);
      }
      this.$emit('validation-updated', this.isValid);
    },

    async fetchResponsibleUsers() {
      let newList = [{ value: '', text: 'Selecione...' }];
      this.isLoading = true;
      try {
        const { model, ok, errors } = await API.post('/execute', {
          path: '/lead-management/qualified-leads/responsible-users',
          method: 'get',
        });

        if (!ok) {
          this.showToast(errors.message, 'Erro', 'danger');
          return;
        }

        if (!model || !model.length) {
          this.showToast(
            'Nenhum usuário responsável encontrado.',
            'Aviso',
            'warning',
          );
          return;
        }

        newList = model.map(user => ({
          value: user.id,
          text: user.name,
        }));
        this.responsibleUserOptions = newList;
      } catch (error) {
        this.showToast('Erro ao buscar usuário responsáveis', 'Erro', 'danger');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
